<template>
    <div class="update-order-gift-card-content">
        <p class="text-xl text-black font-extrabold py-3">Gift card</p>
        <div class="gift-card-container">
            <div class="py-4 px-6 mb-6 header-block">
                <p class="font-extrabold giftcard-title">GIFT CARD</p>
                <div class="info-block">
                    <div v-if="showAmountBalance">
                        <p>Balance: <span class="text-2xl ml-2">${{ giftcard_value ? formatNumber(giftcard_value) : formatNumber(checkedGiftCardData.balance) }}</span></p>
                        <p>Amount: <span class="text-2xl ml-2">${{ giftcard_value ? formatNumber(giftcard_value) : formatNumber(checkedGiftCardData.amount) }}</span></p>
                    </div>
                    <p v-else>Please type gift card code</p>
                </div>
            </div>
            <vs-input v-model="giftcard_code" placeholder="Gift card code" class="w-full mb-6 gift-card-input" @input="giftcard_status = -1" />
            <vs-input v-model="giftcard_value" placeholder="Gift card value" class="w-full mb-6 gift-card-input" v-on:keypress="isNumber($event, 'giftcard_value')" />
            <vs-input v-model="amount" placeholder="Amount to be paid" class="w-full mb-6 gift-card-input" v-on:keypress="isNumber($event, 'amount')" />
            <div class="flex-center">
                <div class="w-1/2 pr-2">
                    <vs-button class="w-full" :disabled="giftcard_code == ''" @click="checkGiftCard">CHECK</vs-button>
                </div>
                <div class="w-1/2 pl-2">
                    <vs-button class="w-full" :disabled="disableAddToCard" @click="addToCard">ADD TO CARD</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "update-order-gift-card-content",
    data() {
        const STATUS_NOT_SOLD_YET = 0;
        const STATUS_SOLD = 1;
        const STATUS_USED_UP = 2;
        const STATUS_CANCELLED = 99;
        return {
            STATUS_NOT_SOLD_YET,
            STATUS_SOLD,
            STATUS_USED_UP,
            STATUS_CANCELLED,
            giftcard_code: "",
            giftcard_value: "",
            amount: "",
            isOpenLoading: false,
            action_type: "",
            valid_giftcard: false,
            giftcard_status: -1,
            renew_giftcard: false,
            reset_giftcard: false,
            giftcard_order_id: null,
            giftcard_id: null
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        // isNumber: function(evt, num) {
        //     evt = (evt) ? evt : window.event;
        //     var charCode = (evt.which) ? evt.which : evt.keyCode;
        //     if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1) ||
        //     ((charCode >= 48 && charCode <= 57) && num.toString().indexOf(".") != -1 && (num.toString().substring(num.toString().indexOf(".") + 1)).length == 2)) {
        //         evt.preventDefault();
        //     } else {
        //         return true;
        //     }
        // },
        isNumber: function(evt, type) {
            let num = this[type];
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && num.toString().indexOf(".") != -1 && (num.toString().substring(num.toString().indexOf(".") + 1)).length == 2)) {
                evt.preventDefault();
            } else {
                if (charCode == 46) {
                    if(num == "") {
                        this[type] = 0;
                    }
                } else if (num === 0 || num === '0') {
                    this[type] = "";
                }
                return true;
            }
        },
        formatNumber(value) {
            return value ? parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0.00';
        },
        checkGiftCard() {
            this.action_type = "Check gift card";
            this.openLoadingInDiv();
            this.giftcard_status = -1;
            this.giftcard_order_id = null;
            this.giftcard_id = null;
            this.renew_giftcard = false;
            this.reset_giftcard = false;
            this.$store.dispatch("goPos/CHECK_GIFTCARD", { code: this.giftcard_code.replaceAll(" ", "") }).then((res) => {
                // this.valid_giftcard = true;
                this.closeLoading();
                console.log(res);
                this.giftcard_status = res.status;
                this.giftcard_order_id = res.order_id;
                this.giftcard_id = res.id;
                // if(this.giftcard_status == this.STATUS_SOLD) {
                //     this.$vs.dialog({
                //         color: 'primary',
                //         title: 'Notification',
                //         text: "This gift card has been sold.Please try again!",
                //         acceptText: 'OK'
                //     })
                // } else 
                if(this.giftcard_status == this.STATUS_USED_UP) {
                    this.$vs.dialog({
                        color: 'primary',
                        title: 'Notification',
                        type: "confirm",
                        text: "This gift card is exhausted. Do you want to renew it?",
                        acceptText: 'OK',
                        cancel: () => { this.renew_giftcard = false; },
                        accept: () => { this.renew_giftcard = true; }
                    })
                } else if(this.giftcard_status == this.STATUS_NOT_SOLD_YET) {
                    if(res.order_id != null) {
                        this.$vs.dialog({
                            color: 'primary',
                            title: 'Notification',
                            type: "confirm",
                            text: `Gift card is processing on order OD${res.order_id}, do you want to reset this gift card?`,
                            acceptText: 'OK',
                            cancel: () => { this.reset_giftcard = false; },
                            // accept: () => { this.reset_giftcard = true; }
                            accept: () => { this.resetGiftCard(); }
                        })
                    }
                } else if(this.giftcard_status == this.STATUS_CANCELLED) {
                    this.$vs.dialog({
                        color: 'primary',
                        title: 'Notification',
                        text: "This gift code is invalid. Please try again!",
                        acceptText: 'OK'
                    })
                }
            }).catch((err) => {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: err,
                    acceptText: 'OK'
                })
            })
        },
        resetGiftCard() {
            let obj = {
                gift_card_id: this.giftcard_id,
                order_id: this.giftcard_order_id
            }
            this.action_type = "Reset gift card";
            this.openLoadingInDiv();
            this.$store.dispatch("goPos/RESET_GIFT_CARD", obj).then(() => {
                this.closeLoading();
                this.reset_giftcard = true;
                this.$vs.dialog({
                    color: 'primary',
                    title: 'Notification',
                    text: "Reset gift card successfully!",
                    acceptText: 'OK'
                })
            }).catch((err) => {
                this.console.log("Error: ", err);
            })
        },
        formatGiftCardCode(code) {
            if(code && code != '') {
                let arr = code.replaceAll(" ", "").split('');
                let result = '';
                for(let i = 0; i < arr.length; i++) {
                    if(i % 4 == 0) {
                        result = result + ' ' + arr[i];
                    } else {
                        result += arr[i];
                    }
                }
                return result;
            }
            return 'N/A';
        },
        addToCard() {
            let item = {
                id: this.giftcard_id,
                name: "Gift Card " + this.formatGiftCardCode(this.giftcard_code),
                price: this.amount,
                quantity: 1,
                amount: this.amount,
                giftcard_value: this.giftcard_value
            }
            this.$emit("addGiftCard", item);
        }
    },
    computed: {
        disableAddToCard() {
            return this.giftcard_code == "" || this.giftcard_value == "" || this.amount == "" || this.giftcard_status == -1 
                // || this.giftcard_status == this.STATUS_SOLD 
                || this.giftcard_status == this.STATUS_CANCELLED || (this.giftcard_status == this.STATUS_USED_UP && !this.renew_giftcard)
                || (this.giftcard_status == this.STATUS_NOT_SOLD_YET && this.giftcard_order_id != null && !this.reset_giftcard);
        },
        showAmountBalance() {
            if(
                // this.giftcard_status == this.STATUS_SOLD || 
                this.giftcard_status == this.STATUS_CANCELLED || (this.giftcard_status == this.STATUS_USED_UP && !this.renew_giftcard)) {
                return false;
            }
            if(this.giftcard_status == this.STATUS_NOT_SOLD_YET && this.giftcard_order_id != null && !this.reset_giftcard) {
                return false;
            }
            if(this.giftcard_status == -1) {
                return false;
            }
            return true;
        },
        checkedGiftCardData() {
            return this.$store.getters["goPos/checkedGiftCardData"];
        }
    }
}
</script>

<style lang="scss">
.update-order-gift-card-content {
    .gift-card-container {
        padding: 20px 45px;
        .header-block {
            border-radius: 10px;
            color: #fff;
            background: linear-gradient(to bottom, #00a6da, #00628c);
            // p {
            //     &:first-child {
            //         margin-bottom: 55px;
            //     }
            // }
            .giftcard-title {
                font-size: 1.6rem;
            }
            .info-block {
                min-height: 90px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
            }
        }
        .gift-card-input {
            input {
                border-color: #aaa;
                border-radius: 10px;
                &::placeholder {
                    font-size: 16px;
                }
            }
        }
        .vs-button {
            border-radius: 10px;
        }
    }
}
</style>